import { DateTime } from "../../../components/DateTime/index.js";
import { UserName } from "../../Users/shared/UserName.js";
import { DownloadPdfButton, EditButton } from "../../../components/Buttons/index.js";
import { ReportEntryFieldsDisplayRenderer } from "./ReportEntryFieldsDisplayRenderer.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportEntryCard.tsx
function ReportEntryCard({ dateMode = "datetime", entry, onDownloadEntryPDF, onEdit }) {
	if (!entry?.formInput) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface relative rounded-sm",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "bg-surface-strong px-sm py-xs rounded-t-sm",
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex flex-wrap justify-between",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs flex flex-wrap items-baseline",
						children: [/* @__PURE__ */ jsx("div", {
							className: "font-bold",
							children: entry.title
						}), /* @__PURE__ */ jsx("div", {
							className: "text-color-subtle",
							children: entry.subTitle
						})]
					}), /* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs flex flex-wrap justify-between",
						children: [/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle",
							children: /* @__PURE__ */ jsx(UserName, { user: entry.createdByUser })
						}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", {
							className: "font-medium",
							children: /* @__PURE__ */ jsx(DateTime, {
								mode: dateMode,
								timestamp: entry.timestamp
							})
						}) })]
					})]
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "relative",
				children: /* @__PURE__ */ jsx("div", {
					className: "p-sm",
					children: /* @__PURE__ */ jsx(ReportEntryFieldsDisplayRenderer, {
						formId: entry.formInput.formId,
						valuesByFieldId: entry.formInput?.fields
					})
				})
			}),
			(onEdit || onDownloadEntryPDF) && /* @__PURE__ */ jsxs("div", {
				className: "space-x-xs bg-surface-subtle px-sm py-xxs flex items-center justify-end rounded-b-sm",
				children: [onDownloadEntryPDF && /* @__PURE__ */ jsx(DownloadPdfButton, {
					size: "sm",
					onClick: onDownloadEntryPDF
				}), onEdit && /* @__PURE__ */ jsx(EditButton, {
					size: "sm",
					onClick: () => onEdit(entry.id)
				})]
			})
		]
	});
}
//#endregion
export { ReportEntryCard };

//# sourceMappingURL=ReportEntryCard.js.map